import { produce } from 'immer';

import { User } from '../../models';
import { ActionType } from './types';

const LAST_LOGIN_ERROR = 'hotMealApp.lastLoginError';

export interface UserState {
  isLoading: boolean;
  isWarningTimeLoading: boolean;
  userInfo: User | null;
  isLogoutLoading: boolean;
  loginError: boolean;
}

const initialState: UserState = {
  isLoading: true, // We need to fetch the user info first thing when the app starts
  isWarningTimeLoading: false,
  userInfo: null,
  isLogoutLoading: false,
  loginError: false,
};

const user = produce((draft: UserState, action) => {
  const { payload } = action;
  switch (action.type) {
    case ActionType.GET_USER_INFO:
      draft.isLoading = true;
      break;
    case ActionType.GET_USER_INFO_FULFILLED:
      draft.isLoading = false;
      draft.userInfo = payload.data;
      break;
    case ActionType.GET_USER_INFO_REJECTED:
      const lastLoginAttempt = localStorage.getItem(LAST_LOGIN_ERROR);
      if (lastLoginAttempt && new Date().getTime() - new Date(lastLoginAttempt).getTime() < 2 * 1000) {
        draft.loginError = true;
      }
      localStorage.setItem(LAST_LOGIN_ERROR, new Date().toISOString());
      draft.isLoading = false;
      draft.userInfo = null;
      break;
    case ActionType.LOGOUT:
      draft.isLogoutLoading = true;
      break;
    case ActionType.LOGOUT_FULFILLED:
      draft.isLogoutLoading = false;
      draft.userInfo = null;
      break;
    case ActionType.LOGOUT_REJECTED:
      draft.isLogoutLoading = false;
      draft.userInfo = null;
      break;
    case ActionType.RESET_LOGIN_ERROR:
      draft.loginError = false;
      break;
    case ActionType.UPDATE_WARNING_TIME:
      draft.isWarningTimeLoading = true;
      break;
    case ActionType.UPDATE_WARNING_TIME_FULFILLED:
      draft.isWarningTimeLoading = false;
      break;
    case ActionType.UPDATE_WARNING_TIME_REJECTED:
      draft.isWarningTimeLoading = false;
      break;
  }
}, initialState);

export default user;
